import { useWindowSize } from "./useSize";

const useIsMobile = () => {
  const { width } = useWindowSize();

  return width < 992;
};

export default useIsMobile;
